module.exports = "https://coursera_assets.s3.amazonaws.com/images/cb929e453ccd097face5648df0ea2428.png";